module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAQpJREFUOI2t1EFKw1AUBdDTNJBuQcQ9dNC5S1AQWxTFLbgUFQruQbFbqPMOugMl2LoGdVAHTST8JmmaeuHC+//df/Pfy0soRw83eEGKn4xptnedaRrhAkustnCBYZ1RF48NjEKOs7MbaGNWNN0os61Zzr/ye1t6Ni08eFqj+0ASYYSDsh7siEOcRzj5B7McpzEGJYnXQjyviOE4WA861gMbB4lOwxutgvV31PBgY8T4xFGwPy3Ec9xm8R36NX7LGLMSw7A3Ofo1OZhFmNQIdsWE9WAv7D/YKZJcOKoRNuVZeN3xHmYPZfV3W5req/h95Rhaf+jbjNKyMquQ4ArPeMdXxjc84VLhBRTxC7d0qNfomj2qAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/add-banner.png
// module id = 1659
// module chunks = 1